import React, { useState, useEffect } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import {
  Title,
  Spinner,
  Permissionkeys,
  Common,
  HttpService,
  API,
  DateFormat
} from '../../config/react'
import DataTable from 'react-data-table-component'
const AbandonedCarts = () => {
  const path = useLocation()
  const history = useHistory()
  const [totalRows, settotalRows] = useState()
  const [loading, setLoading] = useState(true)
  const [AbandonedCartList, setAbandonedCartList] = useState([])
  const [isAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [currentPage, setCurrentPage] = useState(
    path.state
      ? parseInt(path.state.state.page) === 0 || isNaN(path.state.state.page)
        ? 1
        : parseInt(path.state.state.page)
      : 1
  )
  const DefaultFilters = {
    page: currentPage,
    page_size: 10
  }
  const [CustomFilters, setCustomFilters] = useState(DefaultFilters)
  const columns = [
    {
      name: 'Customer',
      selector: (row) => row.customer_name,
      wrap: true
    },
    {
      name: 'Email',
      selector: (row) => row.email,
      wrap: true
    },
    {
      name: 'is Email Sent?',
      selector: (row) => (row.is_reminded ? 'Yes' : 'No'),
      wrap: true
    },
    {
      name: 'Cart Total',
      selector: (row) => row.order_total
    },
    {
      name: 'Created At',
      selector: (row) => <DateFormat value={row.updated_at}></DateFormat>
    },
    {
      name: 'Action',
      selector: (row) => (
        <div className="action-btn">
          <Link
            to={'/sales/abandoned-carts/' + row.abandoned_cart_id + '?page=' + CustomFilters.page}
            className="text-dark"
            title="View"
          >
            <i
              className="mdi mdi-eye"
              aria-hidden="true"
            ></i>{' '}
          </Link>
        </div>
      )
    }
  ]
  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Sales)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AbandonedCarts
    GetAbandonedCartList()
  }, [CustomFilters])
  const GetAbandonedCartList = () => {
    const param = {
      page: CustomFilters.page,
      page_size: CustomFilters.page_size
    }
    setLoading(true)
    HttpService.postApi(API.GetAbandonedCartList, param).then((response) => {
      try {
        setLoading(false)
        const data = response.data.result[1]

        setAbandonedCartList(data)
        settotalRows(response.data.result[0][0].total_row)
        setForceUpdate(!isForceUpdate)
      } catch (error) {
        setLoading(false)
        console.log(error)
      }
    })
  }
  const handlePageChange = (e) => {
    setCurrentPage(e)
    setCustomFilters({ ...CustomFilters, page: e })
  }

  const handlePerRowsChange = (e) => {
    setCurrentPage(1)
    setCustomFilters({ ...CustomFilters, page: 1, page_size: e })
  }

  return !isAuth ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title"> {Title.AbandonedCarts} </h3>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={AbandonedCartList}
                  pagination
                  persistTableHead={true}
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={handlePageChange}
                  responsive={true}
                  progressPending={loading}
                  paginationDefaultPage={currentPage}
                  progressComponent={<Spinner />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AbandonedCarts
